/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FitAndProperCheckReasonDetailViewModel } from './FitAndProperCheckReasonDetailViewModel';
import {
    FitAndProperCheckReasonDetailViewModelFromJSON,
    FitAndProperCheckReasonDetailViewModelFromJSONTyped,
    FitAndProperCheckReasonDetailViewModelToJSON,
} from './FitAndProperCheckReasonDetailViewModel';

/**
 * 
 * @export
 * @interface FitAndProperCheckViewModel
 */
export interface FitAndProperCheckViewModel {
    /**
     * 
     * @type {boolean}
     * @memberof FitAndProperCheckViewModel
     */
    valid?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FitAndProperCheckViewModel
     */
    isHardBlocked: boolean;
    /**
     * 
     * @type {Array<FitAndProperCheckReasonDetailViewModel>}
     * @memberof FitAndProperCheckViewModel
     */
    reasonDetails?: Array<FitAndProperCheckReasonDetailViewModel>;
}

/**
 * Check if a given object implements the FitAndProperCheckViewModel interface.
 */
export function instanceOfFitAndProperCheckViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isHardBlocked" in value;

    return isInstance;
}

export function FitAndProperCheckViewModelFromJSON(json: any): FitAndProperCheckViewModel {
    return FitAndProperCheckViewModelFromJSONTyped(json, false);
}

export function FitAndProperCheckViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FitAndProperCheckViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valid': !exists(json, 'Valid') ? undefined : json['Valid'],
        'isHardBlocked': json['IsHardBlocked'],
        'reasonDetails': !exists(json, 'ReasonDetails') ? undefined : ((json['ReasonDetails'] as Array<any>).map(FitAndProperCheckReasonDetailViewModelFromJSON)),
    };
}

export function FitAndProperCheckViewModelToJSON(value?: FitAndProperCheckViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Valid': value.valid,
        'IsHardBlocked': value.isHardBlocked,
        'ReasonDetails': value.reasonDetails === undefined ? undefined : ((value.reasonDetails as Array<any>).map(FitAndProperCheckReasonDetailViewModelToJSON)),
    };
}

